import axios from "axios";
import React from "react";
import { useQuery } from "react-query";
import { FaMusic, FaPause, FaPlay } from "react-icons/fa";
import { useAudioPlayer } from "./GlobalAudioPlayer";

const LibraryDemosSection = ({ modelData }) => {
  const { data: libraryDemos, isLoading } = useQuery(
    ["library-demos", modelData?._id],
    async () => {
      const res = await axios.get(`/api/model/library-demos/${modelData?._id}`);
      return res.data;
    },
    {
      enabled: !!modelData?._id,
    },
  );

  const { playAudio, pauseAudio, isPlaying, info } = useAudioPlayer();

  if (isLoading) {
    return (
      <div className="tw-w-full tw-py-4">
        <div className="tw-font-bold tw-flex tw-text-xl">Library Demos</div>
        <div className="tw-mt-4 tw-text-sm tw-opacity-60">Loading demos...</div>
      </div>
    );
  }

  if (!libraryDemos?.songDetails?.length) {
    return null;
  }

  return (
    <div className="tw-w-full">
      <div className="tw-font-bold tw-flex tw-text-xl">Library Demos</div>
      <div className="tw-font-semibold tw-mt-1 tw-opacity-40 tw-text-sm">
        Listen to the AI {modelData?.artistname} voice singing popular songs
        from our library.
      </div>

      <div className="tw-grid tw-grid-cols-2 tw-gap-2 tw-mt-4">
        {libraryDemos?.songDetails?.map((song) => {
          const demoUrl = song?.demoInfo?.convertedUrl;
          const songName = song?.metadata?.title || "Unknown Song";
          const artistName = song?.metadata?.artist || "Unknown Artist";
          const isCurrentlyPlaying =
            isPlaying && info?.id === `${modelData?._id}-library-${song?._id}`;

          if (!demoUrl) return null;

          return (
            <div
              key={song?._id}
              className="tw-w-full tw-bg-gray-100 tw-flex tw-items-center tw-rounded-2xl tw-p-3 tw-gap-2"
            >
              <div
                onClick={() => {
                  if (isCurrentlyPlaying) {
                    pauseAudio();
                  } else {
                    playAudio({
                      audio: demoUrl,
                      info: {
                        image: modelData?.image?.url || "/default-album.jpg",
                        name: songName,
                        id: `${modelData?._id}-library-${song?._id}`,
                        artistNames: `${modelData?.artistname} • ${artistName}`,
                      },
                    });
                  }
                }}
                className="tw-bg-white tw-p-2.5 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-xs tw-text-purple-700 tw-cursor-pointer hover:tw-bg-gray-50 tw-transition-colors"
              >
                {isCurrentlyPlaying ? <FaPause /> : <FaPlay />}
              </div>

              <div className="tw-flex tw-flex-col tw-truncate">
                <div className="tw-font-bold tw-truncate">{songName}</div>
                <div className="tw-text-xs tw-text-black/40 tw-truncate">
                  {artistName}
                </div>
              </div>

              {/* <div className="tw-flex tw-items-center tw-justify-center tw-bg-purple-100 tw-rounded-full tw-p-2">
                <FaMusic className="tw-text-purple-700 tw-text-sm" />
              </div> */}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default LibraryDemosSection;
